import { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';
import { homePathForUser } from '../utils/roles.js';
import { apiJson } from '../api/client.js';

export function AcceptInvitePage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { setSession } = useAuth();
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [status, setStatus] = useState('loading');
  const [statusMessage, setStatusMessage] = useState('');

  const token = params.get('token') || '';
  const email = params.get('email') || '';

  useEffect(() => {
    if (!token || !email) {
      setStatus('invalid');
      setStatusMessage('This link is no longer valid.');
      return undefined;
    }

    let cancelled = false;
    apiJson(`/api/portal-invite?${new URLSearchParams({ token, email })}`, { skipAuth: true })
      .then((data) => {
        if (cancelled) {
          return;
        }
        if (data.valid) {
          setStatus('ready');
          return;
        }
        setStatus('invalid');
        setStatusMessage(data.message || 'This link is no longer valid.');
      })
      .catch((err) => {
        if (cancelled) {
          return;
        }
        setStatus('invalid');
        setStatusMessage(err.message || 'This link is no longer valid.');
      });

    return () => {
      cancelled = true;
    };
  }, [token, email]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      const data = await apiJson('/api/portal-invite/accept', {
        method: 'POST',
        skipAuth: true,
        body: {
          token,
          email,
          password,
          password_confirmation: password2,
        },
      });
      setSession(data);
      navigate(homePathForUser(data.user), { replace: true });
    } catch (err) {
      setError(err.message);
      if (/no longer valid|expired/i.test(err.message || '')) {
        setStatus('invalid');
        setStatusMessage(err.message);
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-shell">
      <div className="auth-card">
        <h1>Create your password</h1>
        {status === 'loading' ? <p className="muted">Checking this link…</p> : null}
        {status === 'invalid' ? (
          <>
            <p className="err">{statusMessage}</p>
            <p className="muted">
              <Link to="/">Sign in</Link>
            </p>
          </>
        ) : null}
        {status === 'ready' ? (
          <>
            <p className="muted">Choose a password for {email}</p>
            <form onSubmit={onSubmit} className="stack">
              <label className="field">
                <span>Password</span>
                <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
              </label>
              <label className="field">
                <span>Confirm password</span>
                <input type="password" value={password2} onChange={(e) => setPassword2(e.target.value)} required />
              </label>
              {error ? <p className="err">{error}</p> : null}
              <button type="submit" className="btn-primary" disabled={submitting}>
                {submitting ? 'Activating…' : 'Activate account'}
              </button>
            </form>
          </>
        ) : null}
      </div>
    </div>
  );
}
